import { createContext, useContext } from "react";
import { Theme } from "../../constant/Theme";

// Create a context
interface ThemeContextType {
    theme: Theme;
    toggleTheme: () => void;
  }

  export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
  
  export const useThemeContext = () => {
    const context = useContext(ThemeContext);
    if (!context) {
      throw new Error('useThemeContext must be used within a ThemeProvider');
    }
    return context;
  };